import React from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import LoadingSpin from "../components/Dashboard/LoadingSpin";

export default function AuthRoutes() {
  const user = useSelector((state) => state.user);
  const authChecked = useSelector((state) => state.authStatus.checked);
  const location = useLocation();
  let isLoggedIn = user ? true : false;

  // The access token doesn't survive a hard refresh by itself -- AuthBootstrap
  // silently tries to restore it from the refresh cookie on mount. Show a
  // spinner until that check lands (it times out after 10s), otherwise this
  // would redirect to /login during the brief window before it resolves.
  if (!authChecked) return <LoadingSpin />;

  // LoginForm sends the user back here after logging in, so a deep link (or a
  // session restore that timed out) doesn't dump them on the home page.
  return isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to='/login' state={{ from: location.pathname + location.search }} />
  );
}
